// extracted by mini-css-extract-plugin
export var footer = "w_C";
export var header = "w_8";
export var mobile = "w_bF";
export var scroll = "w_bG";
export var social = "w_bD";